module.exports = __webpack_public_path__ + "static/media/filename (21).226c72e0.png";